import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete } from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details, Translate } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  position: relative;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;
const DataGridContainer = styled.div`
  width: 100%;
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
//   height: 500px;
`;
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
const Input = styled.input`
  display: none;
`;
const VisitEndModal = ({ propData, onClose, remarks, data, id, distributorId, fetchData, status }) => {
  const [changePassword, setChangePassword] = useState(false)
  const [tabValue, setTabValue] = useState(1);
  const { auth, setAuth } = useContext(AuthContext);
  const [roles, setRoles] = useState([])
  const [plantCode, setPlantCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [deletedField, setDeletedFields] = useState([])
  const [hasChanges, setHasChanges] = useState(false);
  const [remark, setRemrak] = useState(remarks)
  const [schoolDetails, setSchoolDetails] = useState([])
  const [distributorDetails, setDistributorDetails] = useState([])
  const [form, setForm] = useState({
    phoneNumber: "" || schoolDetails[0]?.makerContact || distributorDetails[0]?.makerContact || propData?.PhoneNumber,
    extra: "" || propData?.extra,
    tagColleague: "" || propData?.tag_user1 ? true : false,
    partyType: "" || propData?.partyType,
    ownerId: "" || propData?.ownerId,
    partyId: "" || propData?.partyId,
    visitEntryType: "" || propData?.visitEntryType,
    tagUser: "" || propData?.tag_user1,
    superwisor: "" || propData?.superwisor,
    contactPerson: "" || schoolDetails[0]?.makerName || distributorDetails[0]?.makerName || propData?.ContactPerson,
    workDone: "" || propData?.workDone,
    status: "" || propData?.Status,
    tentativeAmount: "" || propData?.tentativeAmount,
    noOfBook: "" || propData?.numberOfBooks,
    explainedCat: "" || propData?.explainedCategory,
    intrestedCat: "" || propData?.interestedCategory,
    feedback: "" || propData?.feedback,
    remark: "" || propData?.remarks,
    followUpRemark: "" || propData?.followUpRemark,
    nextStep: "" || propData?.nextStep,
    followUpDate: propData?.followUpDate ? dayjs(propData?.followUpDate) : '',
    startTime: propData?.startTime ? dayjs(propData?.startTime) : null,
    endTime: propData?.endTime ? dayjs(propData?.endTime) : '',
    startMeetingTime: propData?.start_time_meeting ? dayjs(propData?.start_time_meeting) : '',
    endMeetingTime: propData?.end_time_meeting ? dayjs(propData?.end_time_meeting) : '',
    visitOutcome: '' || propData?.visitOutcome
  })
  const [errors, setErrors] = useState({remark: false,
        followUpDate: false,
        followUpRemark: false,});
  const [employee, setEmployee] = useState([])
  const [assignedEmp, setAssignedEmp] = useState(null)
  const [partyType, setPartyType] = useState()
  const [party, setParty] = useState([])
  const [selectParty, setSelectParty] = useState(null)
  const [date, setDate] = useState()
  const [product, setProduct] = useState()
  const [product1, setProduct1] = useState()
  const [selectProduct, setSelectProduct] = useState([])
  const [selectProduct1, setSelectProduct1] = useState([])
  const [fetchPartyTypes, setfetchedPartyType] = useState(0)
  const [statusWork, setStatusWork] = useState([])
  const [series, setSeries] = useState([])
  const [selectedSeries, setSelectedSeries] = useState(null)
  const [selectedSeries1, setSelectedSeries1] = useState(null)
  const [workDone, setWorkDone] = useState([])
  const [nextStep, setNextStep] = useState([])
  const [feedback, setFeedback] = useState([])
  const [visitType, setVisitType] = useState([])
  const [visitTypeCheck, setVisitTypeCheck] = useState(false)
  const [partyTypeCheck, setPartyTypeCheck] = useState(false)
  const [colleagueUser, setColleagueUser] = useState([])
  const [visitOutcomes, setVisitOutcomes] = useState([]);
  const [startVisit, setStartVisit] = useState(null);
  const [startMeeting, setStartMeeting] = useState(null);
  const [endVisit, setEndVisit] = useState(null);
  const [endMeeting, setEndMeeting] = useState(null);
  const [startVisitP, setStartVisitP] = useState(null);
  const [startMeetingP, setStartMeetingP] = useState(null);
  const [endVisitP, setEndVisitP] = useState(null);
  const [endMeetingP, setEndMeetingP] = useState(null);
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [colleagueRm, setColleagueRm] = useState("")
  const [colleagueRsm, setColleagueRsm] = useState("")
  const [colleagueAsm, setColleagueAsm] = useState("")
  const [colleagueRms, setColleagueRms] = useState([])
  const [colleagueRsms, setColleagueRsms] = useState([])
  const [colleagueAsms, setColleagueAsms] = useState([])
  useEffect(() => {
    // if(tabValue===1){
    //   fetchProduct(plantCode,distributorId)
    // }
    fetchProduct()
    // getSchool()
    getNextStep()
    getFeedback()
    getWorkDone()
    fetchPartyType()
    fetchEmployees()
    getStatus()
    getSeriesCategory()
    getVisitType()
    getVisitOutcomes();
    if (propData) {
      setStartVisit(dayjs(propData?.startTime));
      setEndVisit(dayjs(propData?.endTime));
      setStartMeeting(dayjs(propData?.start_time_meeting));
      setEndMeeting(dayjs(propData?.end_time_meeting));
    }
  }, [])


  useEffect(() => {
    // if(tabValue===1){
    //   fetchProduct(plantCode,distributorId)
    // }
    if (!status) {
      fetchColleague(propData?.ownerId)
      const newDate = new Date(propData.followUpDate)
      formatDate(dayjs(newDate))
      if (propData?.partyType === "1") {
        setfetchedPartyType(1)
        getSchool({
          ownerId: propData?.ownerId
        })
      } else {
        getDistributor({
          ownerId: propData?.ownerId
        })
        setfetchedPartyType(2)
      }
    }
  }, [])

  const now = dayjs().endOf('day');;
  // const handleStartVisitChange = (newValue) => {
  //   const dayjsNewValue = dayjs(newValue);
  //   const unixTimestamp = formatDate('startTime', newValue);
  //   setStartVisit(dayjsNewValue);
  //   setStartVisitP(unixTimestamp);
  //   // setForm((prev) => {
  //   //   return {...prev, startTime: dayjsNewValue}
  //   // })
  //   if (endVisit && newValue && dayjs(endVisit).isBefore(dayjsNewValue)) {
  //     setEndVisit(null);
  //   }
  // };

  const handleStartVisitChange = (newValue) => {
  setStartVisit(newValue);
  setForm((prev) => ({
    ...prev,
    startTime: newValue // Store as Dayjs object or ISO string
  }));
  if (endVisit && newValue && dayjs(endVisit).isBefore(dayjs(newValue))) {
    setEndVisit(null);
  }
};

const handleStartMeetingChange = (newValue) => {
  setStartMeeting(newValue);
  setForm((prev) => {
      return {...prev, startMeetingTime: newValue}
    })
     if (endMeeting && newValue && dayjs(endMeeting).isBefore(newValue)) {
      setEndMeeting(null);
    }
  };

  // const handleStartMeetingChange = (newValue) => {
  //   const startVisitTime = dayjs(startVisit);
  //   if (newValue && startVisitTime && newValue.isBefore(startVisitTime)) {
  //     return;
  //   }
  //   const unixTimestamp = formatDate('startMeetingTime', newValue);
  //   setStartMeeting(startVisitTime);
  //   setStartMeetingP(unixTimestamp);
  //   // setForm((prev) => {
  //   //   return {...prev, startMeetingTime: startVisitTime}
  //   // })
  //   if (endMeeting && newValue && dayjs(endMeeting).isBefore(startVisitTime)) {
  //     setEndMeeting(null);
  //   }
  // };

  useEffect(() => {
    if (distributorDetails[0]) {
      setForm(prev => ({
        ...prev,
        phoneNumber: distributorDetails[0]?.makerContact || "",
        contactPerson: distributorDetails[0]?.makerName || ""
      }));
    }
  }, [distributorDetails]);

  useEffect(() => {
    if (schoolDetails[0]) {
      setForm(prev => ({
        ...prev,
        phoneNumber: schoolDetails[0]?.makerContact || "",
        contactPerson: schoolDetails[0]?.makerName || ""
      }));
    }
  }, [schoolDetails]);

  useEffect(() => {
    if (form?.tagColleague) {
      setForm(prev => ({
        ...prev,
        tagColleague: true,
        tagUser:propData?.tag_user1,
        superwisor:propData?.superwisor
      }));
      // if (propData?.colleagueRsm) setColleagueRsm(propData?.colleagueRsm);
      // if (propData?.superwisor) setColleagueAsm(propData?.superwisor);
      // if (propData?.tag_user1) setColleagueRm(propData?.tag_user1);
      setColleagueAsm(propData?.superwisor || "");
      setColleagueRm(propData?.tag_user1 || "");
    }
    else {
      setForm(prev => ({
        ...prev,
        tagUser:"",
        superwisor:""
      }));
      setColleagueAsm("")
      setColleagueRm("")
      setColleagueRsm("")
    }
  }, [form?.tagColleague, propData])

  // const handleEndVisitChange = (newValue) => {
  //   const endTime = dayjs(newValue);
  //   if (newValue && endTime && newValue.isBefore(endTime)) {
  //     return;
  //   }
  //   const unixTimestamp = formatDate('endTime', newValue);
  //   setEndVisit(endTime);
  //   setEndVisitP(unixTimestamp);
  //   // setForm((prev) => {
  //   //   return {...prev, endTime: endTime}
  //   // })
  // };
  const handleEndVisitChange = (newValue) => {
  setEndVisit(newValue);
  setForm((prev) => ({
    ...prev,
    endTime: newValue
  }));
};

  // const handleEndMeetingChange = (newValue) => {
  //   const dayjsNewValue = dayjs(newValue);
  //   const unixTimestamp = formatDate('endMeetingTime', newValue);
  //   setEndMeeting(dayjsNewValue);
  //   setEndMeetingP(unixTimestamp);
  //   // setForm((prev) => {
  //   //   return {...prev, endMeetingTime: dayjsNewValue}
  //   // })
  // };

const handleEndMeetingChange = (newValue) => {
  setEndMeeting(newValue);
  setForm((prev) => ({
    ...prev,
    endMeetingTime: newValue
  }));
};

  const getSeriesCategory = async () => {
    let results = await window.Platform.database.getSeriesCategory();
    setSeries(results.data)
  }
  const fetchColleague = async (data) => {
    let results = await window.Platform.database.getManager({ ownerId: data });
    setColleagueUser(results.data)
  }

  const getWorkDone = async () => {
    let results = await window.Platform.database.getWorkDone();
    setWorkDone(results.data)
  }

  const getNextStep = async () => {
    let results = await window.Platform.database.getNextStep();
    setNextStep(results.data)
  }

  const getFeedback = async () => {
    let results = await window.Platform.database.getFeedback();
    setFeedback(results.data)
  }
  const getVisitType = async () => {
    let results = await window.Platform.database.getRouteVisitType();
    setVisitType(results.data)
  }

  const getVisitOutcomes = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.getVisitOutcomes();
      setVisitOutcomes(results.data);
      // const jsonArrayWithId = results?.data?.map((obj, index) => ({
      //   ...obj,
      //   id: index + 1,
      // }));
      // setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  }

  const fetchProductById = async (data, data1) => {
    setLoading(true)
    const results = await window.Platform.database.fetchProductById({ id: data });
    if (!data1) {
      setProduct(results.data)
    }
    else {
      setProduct1(results.data)
    }
    setLoading(false)
  }

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const changeHandler = (fieldName, value) => {
    if (fieldName === "phoneNumber" || fieldName === "tentativeAmount" || fieldName === "noOfBook") {
      const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
    }
    else {
      console.log(value)
      setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
    }
  };

  // const changeHandler = (fieldName, value) => {
  //    if(fieldName==="tentativeAmount"||fieldName==="noOfBook"){
  //   const sanitizedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
  //   setForm((prevForm) => ({ ...prevForm, [fieldName]: sanitizedValue }))
  // }
  // else{
  //   setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  // }
  // };

  const getDistributor = async (data) => {
    setLoading(true)
    setParty([])
    const results = await window.Platform.database.getDistributor(data);
    setParty(results.data)
    setSelectParty(null)
    if (!status) {
      const filteredEmp = results?.data?.filter((data) => data.distributorID === propData.partyId)
      setSelectParty(filteredEmp[0])
    }
    setLoading(false)
  }

  const partyTypeHandler = (data) => {
    if (data === "cQpLw8vwZf") {
      changeHandler("partyType", 1)
      setfetchedPartyType(1)
      getSchool({ ownerId: form?.ownerId })
      setPartyTypeCheck(false)
    } else if (data === "P6E9TGXewd") {
      changeHandler("partyType", 0)
      setfetchedPartyType(2)
      setPartyTypeCheck(false)
      getDistributor({ ownerId: form?.ownerId })
    } else if (data === "GXjqJfCSLp") {
      setPartyTypeCheck(true)
    } else {
      setPartyTypeCheck(true)
    }
    // changeHandler("partyType", data)
  }
  const visitTypeHandler = (data) => {
    if (data === "NKlytW4260") {
      setVisitTypeCheck(true)
    } else {
      setVisitTypeCheck(false)
    }
    changeHandler("visitEntryType", data)
  }
  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setAsms(results?.data)
        // setColleagueAsms(results?.data)
        setRms(results?.data1)
        // setColleagueRms(results?.data1)
        setEmployee(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
        // setColleagueRms(results?.data)
        setEmployee(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        // setColleagueAsm("")
        // setColleagueRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        // setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
        setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
        // setColleagueAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setRm("")
        // setColleagueRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        // setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
        setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  async function getUsersColleague(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setColleagueAsms(results?.data)
        setColleagueRms(results?.data1)
        setEmployee(results?.data1)
      }
      if (role == 'asm') {
        setColleagueRms(results?.data)
        setEmployee(results?.data)
      }
    } else {
      if (role == 'rsm') {
        setColleagueAsm("")
        setColleagueRm("")
        setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
        setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
        setColleagueAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'asm') {
        setColleagueRm("")
        setColleagueRms(allUsers?.filter((ele) => ele.role == 'se'))
        setEmployee(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }
  }

  useEffect(() => {
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
      getAllUsersColleague()
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  useEffect(() => {
  if (form?.visitOutcome !== "FpPIgxcOrY") {
    setForm((prev) => ({
      ...prev,
      followUpDate: ""
    }));
  }
}, [form?.visitOutcome]);

  //   useEffect(() => {
  //   if (propData?.tag_user1) {
  //     setForm(prev => ({
  //       ...prev,
  //       tagColleague: true
  //     }));
  //     // if (propData?.colleagueRsm) setColleagueRsm(propData?.colleagueRsm);
  //     if (propData?.superwisor) setColleagueAsm(propData?.superwisor);
  //     if (propData?.tag_user1) setColleagueRm(propData?.tag_user1);
  //   }
  // }, [propData]);

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setEmployee(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
    // setColleagueRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    // setColleagueRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    // setColleagueAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }

  async function getAllUsersColleague() {
    let results = await window.Platform.database.fetchEmployees()
    setAllUsers(results?.data)
    setEmployee(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setColleagueRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
    setColleagueRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
    setColleagueAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
  }

  const getSchoolById = async (schoolId) => {
    setLoading(true);
    const result = await window.Platform.database.getSchoolDataBasedOnId({ schoolId: schoolId });
    setSchoolDetails(result.data)
    setLoading(false);
  };

  const getDistributorById = async (distributorID) => {
    setLoading(true);
    const result = await window.Platform.database.getDistributorByID({ id: distributorID });
    setDistributorDetails(result.data)
    setLoading(false);
  };

  const formatDate = (type = null, data) => {
    const timestamp = new Date(data);
    const datePickerResponse = new Date(data);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}/${month}/${day}`;
    const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
    setDate(data)
    if (type) {
      changeHandler(type, unixTimestamp)
    } else {
      changeHandler("followUpDate", unixTimestamp)
    }
  }
  const renderContent = (params) => {
    return (
      <div style={{ maxHeight: "510px", height: "505px", overflowY: "auto" }}>
 <Stack direction={"row"} spacing={2} padding={2}>
          {userData?.role.includes('admin') &&  <FormControl fullWidth>
            <InputLabel id="select-label" >Select HO:</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={rsm}
              onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value) }}
              label="Select HO:"
            >
              <MenuItem value="">All</MenuItem>
              {rsms?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {/* {option.name} */}
                  {option.name} - {option.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>}
           {userData?.role != 'asm' &&   <FormControl fullWidth>
            <InputLabel id="select-label" >Select ARM:</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={asm}
              onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value) }}
              label="Select ARM:"
            >
              <MenuItem value="">All</MenuItem>
              {asms?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {/* {option.name} */}
                  {option.name} - {option.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>}
          <FormControl fullWidth>
            <InputLabel id="select-label"  required error={errors.ownerId ? true : false}>Select RM</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.ownerId || rm}
              onChange={(e) => { setRm(e.target.value); changeHandler("ownerId", e.target.value) }}
              label="Select RM:"
               required error={errors.ownerId ? true : false}
            >
              <MenuItem value="">All</MenuItem>
              {rms?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {/* {option.name} */}
                  {option.name} - {option.username}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Contact Person Mobile No" disabled={visitTypeCheck} value={form?.phoneNumber || ""} type="text" fullWidth onChange={(e) => changeHandler("phoneNumber", e.target.value)} required error={errors.contactPerson ? true : false} />
          <TextField label="Contact Person Name" value={form?.contactPerson || ""} disabled={visitTypeCheck} type="text" fullWidth onChange={(e) => changeHandler("contactPerson", e.target.value)} required error={errors.personName ? true : false} />
        </Stack>
          <Stack direction={"row"} spacing={2} padding={2}>
          <Box sx={{ flex: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <DateTimePicker
                sx={{ width: '100%' }}
                label="End Meeting Time"
                value={form.endMeetingTime ? dayjs(form.endMeetingTime) : null}
                // value={form.endMeetingTime ? dayjs.unix(form.endMeetingTime) : null}
                onChange={handleEndMeetingChange}
                disabled={!startMeeting}
                // readOnly={propData?.end_time_meeting ? true : false}
                maxDateTime={now}
                minDateTime={startMeeting}
              /> */}
                <DateTimePicker
  sx={{ width: '100%' }}
  label="End Meeting Time"
  value={form.endMeetingTime ? dayjs(form.endMeetingTime) : null}
  onChange={handleEndMeetingChange}
   minDateTime={form.startMeetingTime ? dayjs(form.startMeetingTime) : null}
  maxDateTime={now}
/>
            </LocalizationProvider>
          </Box>

          <Box sx={{ flex: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <DateTimePicker
                sx={{ width: '100%' }}
                label="End Visit Time"
                // value={form.endTime ? dayjs.unix(form.endTime) : null}
                value={form.endTime ? dayjs(form.endTime) : null}
                onChange={handleEndVisitChange}
                disabled={!startVisit}
                // readOnly={propData?.endTime ? true : false}
                maxDateTime={now}
                minDateTime={endMeeting}
              /> */}
                   <DateTimePicker
  sx={{ width: '100%' }}
  label="End Visit Time"
  value={form.endTime ? dayjs(form.endTime) : null}
  onChange={handleEndVisitChange}
  minDateTime={form.endMeetingTime ? dayjs(form.endMeetingTime) : null}
  maxDateTime={now}
/>
            </LocalizationProvider>
          </Box>
        </Stack>
        {/* <Stack direction={"row"} spacing={2} padding={2}>
          <Autocomplete
            options={series}
            getOptionLabel={(option) => `${option?.seriesName}`}
            getOptionValue={(option) => option?.seriesTableId || ''}
            style={{ width: "60%" }}
            value={selectedSeries}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("explainedCat", value?.seriesTableId)
              if (value) {
                setSelectedSeries(value)
                fetchProduct(3, value?.seriesTableId)
              }
              else {
                setSelectedSeries(value)
                fetchProduct(3)
              }
            }}
            onInputChange={(e, value) => {
              const matchingOption = employee.find((option) => option.name === value.name);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Explained Category"}
                required
                variant="outlined"
                error={errors.explainedCategory ? true : false}
              />
            )} />
          <Autocomplete
            multiple
            options={product}
            getOptionLabel={(option) => `${option?.nameSku}`}
            getOptionValue={(option) => option?.skuId || ''}
            style={{ width: "100%" }}
            value={selectProduct}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("productExp", value?.skuId)
              setSelectProduct(value)
            }}
            onInputChange={(e, value) => {
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Explained Product"}
                required
                variant="outlined"
                error={errors.explainedProduct ? true : false}
              />
            )} />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl fullWidth variant="outlined" error={!!errors.interestedCategory}>
            <InputLabel required>Interested Category</InputLabel>
            <Select
              value={form.intrestedCat || ''}
              onChange={(event) => {
                const selectedValue = event.target.value;
                const selectedOption = series.find(option => option.seriesTableId === selectedValue);
                changeHandler("intrestedCat", selectedOption?.seriesTableId);
                if (selectedOption) {
                  setSelectedSeries1(selectedOption);
                  fetchProduct(2, selectedOption.seriesTableId);
                } else {
                  setSelectedSeries1(null);
                  fetchProduct(2);
                }
              }}
              label="Interested Category"
              disabled={loading}
            >
              {series.length > 0 ? (
                series.map((option) => (
                  <MenuItem key={option.seriesTableId} value={option.seriesTableId}>
                    {option.seriesName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>{loading ? "Loading..." : "No option"}</MenuItem>
              )}
            </Select>
          </FormControl>
          <Autocomplete
            multiple
            options={product1}
            getOptionLabel={(option) => `${option?.nameSku}`}
            getOptionValue={(option) => option?.skuId || ''}
            style={{ width: "100%" }}
            value={selectProduct1}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("productInt", value?.skuId)
              setSelectProduct1(value)
            }}
            onInputChange={(e, value) => {
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Interested Product"}
                required
                variant="outlined"
                error={errors.interestedProduct ? true : false}
              />
            )} />
        </Stack> */}
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Status Of Visit</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              label="Status Of Visit"

              value={form?.statusOfVisit || ""}
              onChange={(e) => changeHandler("statusOfVisit", e.target.value)}
            >
              <MenuItem value="Interested"> Interested </MenuItem>
              <MenuItem value="In Discussion"> In Discussion </MenuItem>
              <MenuItem value="Not Interested "> Not Interested </MenuItem>
            </Select>
          </FormControl> */}
          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label" required error={errors.status ? true : false}>Status Of Visit</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form.status || ""}
              disabled={visitTypeCheck || partyTypeCheck}
              onChange={(e) => changeHandler("status", e.target.value)}
              label="Status Of Visit"
              required
              error={errors.status ? true : false}
            >
              {statusWork?.map((option, optionIndex) => (
                <MenuItem key={option.statusTypeId} value={option.statusTypeId}>
                  {option.statusTypeName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Work Done</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              label="Work Done"
              value={form?.workDone || ""}
              onChange={(e) => changeHandler("workDone", e.target.value)}
            >
              <MenuItem value=" Product Disscussed / Orientation"> Product Disscussed / Orientation </MenuItem>
              <MenuItem value="Sales Call Attended"> Sales Call Attended </MenuItem>
            </Select>
          </FormControl> */}
          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label" required error={errors.workDone ? true : false}>Work Done</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.workDone || ""}
              onChange={(e) => changeHandler("workDone", e.target.value)}
              label="Select Option"
              disabled={visitTypeCheck}
              required
              error={errors.workDone ? true : false}
            >
              {workDone?.map((option, optionIndex) => (
                <MenuItem key={option.workDoneTableId} value={option.workDoneTableId}>
                  {option.workDoneName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>






        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">product Category</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              label="product Category"
              value={form?.categorySeriesExplained || []}
              onChange={(e) => changeHandler("product_category", e.target.value)}
            >
              <MenuItem value={[]}> All </MenuItem>
            </Select>
          </FormControl> */}

          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Feedback</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.feedback || ""}
              onChange={(e) => changeHandler("feedback", e.target.value)}
              label="Feedback"
            >
              {feedback?.map((option, optionIndex) => (
                <MenuItem key={option.feedbackId} value={option.feedbackId}>
                  {option.feedbackName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth variant="outlined" disabled={loading}>
            <InputLabel>Select Visit Outcome</InputLabel>
            <Select
              value={form.visitOutcome || ''}
              onChange={(event) => {
                const selectedValue = event.target.value;
                changeHandler("visitOutcome", selectedValue);
              }}
              label="Select Visit Outcome"
            >
              {visitOutcomes.length > 0 ? (
                visitOutcomes.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>{loading ? "Loading..." : "No option"}</MenuItem>
              )}
            </Select>
          </FormControl>
        </Stack>
      
        {/* <Stack direction={"row"} spacing={2} padding={2}>

          <Autocomplete
            options={series}
            getOptionLabel={(option) => `${option?.seriesName}`}
            getOptionValue={(option) => option?.seriesTableId || ''}
            style={{ width: "100%" }}
            value={selectedSeries}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("explainedCat", value?.seriesTableId)
              if (value) {
                setSelectedSeries(value)
                fetchProduct(3, value?.seriesTableId)
              }
              else {
                setSelectedSeries(value)
                fetchProduct(3)
              }
            }}
            onInputChange={(e, value) => {
              const matchingOption = employee.find((option) => option.name === value.name);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Explained Category"}
                required
                variant="outlined"
                error={errors.explainedCategory ? true : false}
              />
            )} />

          <Autocomplete
            multiple
            options={product}
            getOptionLabel={(option) => `${option?.nameSku}`}
            getOptionValue={(option) => option?.skuId || ''}
            style={{ width: "100%" }}
            value={selectProduct}
            noOptionsText={loading ? "Loading..." : "No option"}
            onChange={(event, value) => {
              changeHandler("productExp", value?.skuId)
              setSelectProduct(value)
            }}
            onInputChange={(e, value) => {
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Explained Product"}
                required
                variant="outlined"
                error={errors.explainedProduct ? true : false}
              />
            )} />
        </Stack> */}








        {/* <Stack direction={"row"} spacing={2} padding={2}> */}
        {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <InputLabel id="select-label">Feedback</InputLabel>
            <Select
              labelId="select-label"
              id="select"
              value={form?.feedback || ""}
              onChange={(e) => changeHandler("feedback", e.target.value)}
              label="Feedback"
            >
              {feedback?.map((option, optionIndex) => (
                <MenuItem key={option.feedbackId} value={option.feedbackId}>
                  {option.feedbackName}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
        {/* <TextField label="Remarks" value={form?.remark} type="text" fullWidth onChange={(e) => changeHandler("remark", e.target.value)}  required error={errors.remark ? true : false}//> */}
        {/* </Stack> */}
          {form?.visitOutcome == "FpPIgxcOrY" &&
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <FormControl fullWidth variant="outlined" disabled={loading}>
            <InputLabel>Select Visit Outcome</InputLabel>
            <Select
              value={form.visitOutcome || ''}
              onChange={(event) => {
                const selectedValue = event.target.value;
                changeHandler("visitOutcome", selectedValue);
              }}
              label="Select Visit Outcome"
            >
              {visitOutcomes.length > 0 ? (
                visitOutcomes.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>{loading ? "Loading..." : "No option"}</MenuItem>
              )}
            </Select>
          </FormControl> */}
            <FormControl fullWidth>
                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Follow Up Date"
                disabled={visitTypeCheck || loading || partyTypeCheck}
                value={form.followUpDate ? dayjs(form.followUpDate) : null}
                sx={{ width: "100%" }}
                format="YYYY/MM/DD"
                onChange={(data) => changeHandler('followUpDate', moment(Number(data)).format('YYYY/MM/DD'))}
                disablePast={form.followUpDate ? false : true}
                // readOnly={form.followUpDate ? true : false}
              />
            </LocalizationProvider> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Follow Up Date"
                  value={form.followUpDate ? dayjs(form.followUpDate) : null}
                  sx={{ width: "100%" }}
                  format="YYYY/MM/DD"
                onChange={(data) => changeHandler('followUpDate', moment(Number(data)).format('YYYY/MM/DD'))}
                  slotProps={{
                    textField: {
                      error: errors.followUpDate,
                      fullWidth: true,
                    }
                  }}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl fullWidth >
              <TextField
                label="Follow Up Remark"
                name="followUpRemark"
                // value={endVisitForm.followUpRemark || ''}
                value={form?.followUpRemark || ''}
                // onChange={handleEndVisitFormChange}
                onChange={(e) => changeHandler("followUpRemark", e.target.value)}
                fullWidth
                multiline
                required
                error={errors.followUpRemark ? true : false}
              // error={errors.followUpRemark}
              // helperText={errors.followUpRemark ? 'Follow Up Remark is required.' : ''}
              />
            </FormControl>

        </Stack>
          }

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
          {status ? <Button variant="contained" disabled={loading} onClick={() => onsubmit(form)} >
            End Visit
          </Button> : <Button variant="contained" onClick={() => handleEdit(form)} >
            Update Visit
          </Button>}
        </div>
      </div>
    );
  };

  const fetchEmployees = async () => {
    try {
      setLoading(true)
      const results = await window.Platform.database.getUsersForWork();
      // setEmployee(results.data)
      setAssignedEmp(null)
      if (!status) {
        const filteredEmp = results?.data?.filter((data) => data.id === propData.ownerId)
        setAssignedEmp(filteredEmp[0])
      }
      setLoading(false)
    }
    catch (e) {
      setLoading(false)
      console.log(e)
    }

  }
  const fetchProduct = async (data, data1) => {
    try {
      setLoading(true)
      if (!data && status) {
        const results = await window.Platform.database.fetchProduct(data);
        setProduct(results.data)
        setProduct1(results.data)
      }
      else if (data && status) {
        if (data === 1) {
          const results = await window.Platform.database.fetchProduct();
          setProduct(results.data)
        } else if (data === 2) {
          const results = await window.Platform.database.fetchProductByCategory({ id: data1 });
          setProduct1(results.data)
        }
        else {
          const results = await window.Platform.database.fetchProductByCategory({ id: data1 });
          setProduct(results.data)
        }
      }
      else if (!status && !data) {
        // selectProduct1(null)
        // selectProduct1(null)
        const results = await window.Platform.database.fetchProduct();
        setProduct(results.data)
        setProduct1(results.data)
        const resultArray = propData?.productExplained?.split(',');
        const resultArray1 = propData?.productInterested?.split(',');
        const filteredData = results?.data?.filter(item => resultArray.includes(item.skuId));
        const filteredData1 = results?.data?.filter(item => resultArray1.includes(item.skuId));
        setSelectProduct(filteredData)
        setSelectProduct1(filteredData1)
      }
      setLoading(false)
    }
    catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const getStatus = async () => {
    try {
      const results = await window.Platform.database.getStatusType(data);
      setStatusWork(results.data)
    }
    catch (err) {
      console.log(err)
    }
  }

  const validateForm = (data) => {
    const errors = {};
    console.log(data, "data of End visit");
    const explainedProducts = selectProduct?.map(item => item.skuId);
    const interestedProducts = selectProduct1?.map(item => item.skuId);
    // if (!rm) {
    //   errors.rm = "RM is required";
    // }
    if(!data?.remark?.trim()){
      errors.remark = "Remark is required";
    }
    if (!data.visitEntryType?.trim()) {
      errors.visitType = "Visit type is required";
    }
     if (!data.ownerId) {
      errors.ownerId = "RM is required";
    }
    // if (!data.partyType?.trim()) {
    //   errors.partyType = "Party type is required";
    // }
    if (!data.partyId?.trim()) {
      errors.party = "Party is required";
    }
    if (!data.contactPerson?.trim()) {
      errors.personName = "Person name is required";
    }
    if (!data.phoneNumber?.trim()) {
      errors.contactPerson = "Person contact is required";
    }
    //  if (!data.followUpRemark?.trim() ) {
    //   errors.followUpRemark = "FollowUp remark is required";
    // }
    // if (!data.status?.trim()) {
    //   errors.status = "Status is required";
    // }

    // if (!data.workDone?.trim()) {
    //   errors.workDone = "Work done is required";
    // }

    // if (!data.explainedCat?.trim()) {
    //   errors.explainedCategory = "Explained category is required";
    // }

    // if (!explainedProducts?.length) {
    //   errors.explainedProduct = "Explained product is required";
    // }

    // if (!data.intrestedCat?.trim()) {
    //   errors.interestedCategory = "Interested category is required";
    // }

    // if (!interestedProducts?.length) {
    //   errors.interestedProduct = "Interested product is required";
    // }
    return errors;
  };

  const onsubmit = async (data) => {
    setLoading(true);
    try {
      //       if(!partyTypeCheck || !visitTypeCheck){
      //         if(!form.ownerId||!form.visitEntryType||!form.partyType||!form.partyId
      //           ||!form.contactPerson||!form.phoneNumber||!form.status||
      //           !form?.workDone
      //           ){
      //       window.NotificationUtils.showWarning("Please fill all required fields")
      // return;
      //           }
      //       }
      const errors = validateForm(data);
      setErrors(errors);
        let hasError = false;
        let newErrors = { ...errors };
        if (!data.remark || data.remark.trim() === "") {
            newErrors.remark = true;
            hasError = true;
    setLoading(false);
        } else {
            newErrors.remark = false;
               setLoading(false);
        }

      if (data?.visitOutcome === "FpPIgxcOrY") {
            if (!data.followUpDate) {
                newErrors.followUpDate = true;
                hasError = true;
                   setLoading(false);
            } else {
                newErrors.followUpDate = false;
                   setLoading(false);
            }
            if (!data.followUpRemark || data.followUpRemark.trim() === "") {
                newErrors.followUpRemark = true;
                hasError = true;
                   setLoading(false);
            } else {
                newErrors.followUpRemark = false;
                   setLoading(false);
            }
        } else {
            newErrors.followUpDate = false;
            newErrors.followUpRemark = false;
               setLoading(false);
        }

        setErrors(newErrors);
        if (hasError) return;
      if (Object.keys(errors).length === 0) {
        // setLoading(true);
        const arrayOfIds = selectProduct?.map((item) => item.skuId);
        const arrayOfIds1 = selectProduct1?.map((item) => item.skuId);
        const payload = {
          ...data,
          // ownerId: rm,
          productExp: arrayOfIds,
          productInt: arrayOfIds1,
          // productCategory: [],
          followUpDate: Math.floor(new Date(data.followUpDate).getTime() / 1000),
          // superWisor: colleagueAsm,
          // tagUser: colleagueRm
        }
        // console.log(payload, "payload of add visit");
        // setLoading(false);
        // return;
        const results = await window.Platform.database.addVisit(payload);
        if (results.status === false) {
          window.NotificationUtils.showSuccess("Visit added successfully!");
          setLoading(false);
          onClose();
          fetchData();
        } else {
          window.NotificationUtils.showError(results.message);
          setLoading(false);
        }
      } else {
        window.NotificationUtils.showError("Please fill the form correctly.");
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const fetchPartyType = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.fetchPartyType(details);
      setPartyType(results.data)
      setLoading(false)
      // setDetails(results.data[0]);
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  const getSchool = async (details) => {
    try {
      setLoading(true)
      setParty([])
      const results = await window.Platform.database.getAllSchool(details);
      setParty(results.data)
      setSelectParty(null)
      if (!status) {
        const filteredEmp = results?.data?.filter((data) => String(data.schoolId) == String(propData.partyId))
        setSelectParty(filteredEmp[0])
      }
      setLoading(false)
      // setDetails(results.data[0]);
      // setProduct(results.data)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }

  const handleEdit = async (data) => {
    try {
      const errors = validateForm(data);
      setErrors(errors);
      if (Object.keys(errors).length === 0) {
        setLoading(true);
        const arrayOfIds = selectProduct?.map(item => item.skuId);
        const arrayOfIds1 = selectProduct1?.map(item => item.skuId);
        const finalData = {
          ...data,
          productExp: arrayOfIds,
          productInt: arrayOfIds1,
          id: propData.visitId,
          followUpDate: Math.floor(new Date(data.followUpDate).getTime() / 1000),
          // startTime: Math.floor(new Date(data.startTime).getTime() / 1000),
          // endTime: Math.floor(new Date(data.endTime).getTime() / 1000),
          // startMeetingTime: Math.floor(new Date(data.startMeetingTime).getTime() / 1000),
          // endMeetingTime: Math.floor(new Date(data.endMeetingTime).getTime() / 1000)
             startTime: dayjs(form?.startTime) || propData?.startTime,
    endTime:  dayjs(form?.endTime) || propData?.endTime,
    startMeetingTime: dayjs(form?.startMeetingTime) || propData?.start_time_meeting,
    endMeetingTime:  dayjs(form?.endMeetingTime) || propData?.end_time_meeting
        };
        // console.log(finalData, "final data of edit visit");
        // setLoading(false);
        // return;
        let results = await window.Platform.database.updateVisit(finalData);
        if(results.status === true) {
          window.NotificationUtils.showError(results.message);
          setLoading(false)
          return;
        }
        onClose();
        fetchData();
        setLoading(false);
      } else {
        window.NotificationUtils.showWarning("Please fill all required fields to proceed");
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(true)
    }
  }
  return (
    <Dialog disableEnforceFocus maxWidth="md" fullWidth={true} open={true} >
      {loading && <OpaqueLoading />}
      <ModalHeaderContainer style={{ marginBottom: 2, paddingBottom: 3 }}>
        <Typography variant={isMobile ? "h6" : "h5"}>
          {status ? "Add Visit" : "Edit Visit"}
          <Tooltip title="Order Id">
            {id}
          </Tooltip>
        </Typography>
        <IconButton onClick={onClose} >
          <CloseOutlined />
        </IconButton>
      </ModalHeaderContainer>
      <TableContainer>
        <TabsContainer>
          <StyledTabs
            variant="fullWidth"
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="End Visit" />
          </StyledTabs>
          {renderContent()}
        </TabsContainer>
      </TableContainer>
    </Dialog>
  );
};

export default VisitEndModal;